// Desktop-vs-mobile view preference for office roles (Project Manager, Accounting),
// who have BOTH a desktop layout and the mobile app. On first use the view auto-detects
// from screen size; the "Desktop view" / "Mobile view" switch buttons override that and
// remember the choice on this device.
const KEY = 'titan_view_pref';

export function isMobileDevice() {
  try { return window.matchMedia('(max-width: 820px)').matches; }
  catch { return false; }
}

export function preferredView() {
  const saved = localStorage.getItem(KEY);
  if (saved === 'mobile' || saved === 'desktop') return saved;
  return isMobileDevice() ? 'mobile' : 'desktop';
}

export function setPreferredView(v) {
  if (v === 'mobile' || v === 'desktop') localStorage.setItem(KEY, v);
}

// Where each office role lands in the desktop layout.
export function desktopHome(role) {
  if (role === 'Executive')      return '/admin';
  if (role === 'ProjectManager') return '/admin/pm-dashboard';
  if (role === 'Accounting')     return '/admin/timesheets';
  return '/admin/new-projects';
}
